<script setup lang="ts">
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/core/components/ui/dialog';
import Icon from "@/core/components/icon/Icon.vue";
import MarkdownView from "@/core/components/markdown/Markdown.vue";

defineProps<{
    invoicing: string
}>();
</script>

<template>
  <Dialog>
    <DialogTrigger>
      <div class="flex text-xs items-center justify-center gap-2 cursor-pointer font-bold">
        <Icon name="mdi-bank" :size="14" class="pb-1" />
        Infos facturation |
      </div>
    </DialogTrigger>
    <DialogContent class="flex flex-col max-h-[90dvh]">
      <DialogHeader>
        <DialogTitle>Modalités de facturation</DialogTitle>
        <DialogDescription />
      </DialogHeader>
      <div class="min-h-auto overflow-y-auto px-2">
        <MarkdownView class="text-sm leading-6" :content="invoicing" />
      </div>
    </DialogContent>
  </Dialog>
</template>

<style scoped>
:deep(.markdown *) {
    @apply text-base;
}
</style>
